import React, {useState, useEffect} from "react";



export default function Supporto() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Al caricamento della pagina, attiva il fading
    setIsVisible(true);
  }, []);


    return (
    <div className={`text-white font-bold transition-opacity duration-[2000ms] ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>   
      <div className="p-8 text-gray-800">
            <h1 className="text-3xl font-bold mb-4">Supporto</h1>
            <p>Hai bisogno di aiuto? Contattaci alla mail <a href="mailto:assistenza@ciesseimpiantisrl.it" className="text-blue-600 underline">assistenza@ciesseimpiantisrl.it</a></p>
      </div>
    </div>  
    );
  }
  